import { apiClient } from '@core/api/ApiClientFactory';

export const dataExportService = {
    async exportBlobByUrl(url: string): Promise<Blob> {
        try {
            const response = await apiClient.get(url, { responseType: 'blob' });
            return response.data;
        } catch (error) {
            console.error('[DataExportService] Error exporting blob:', error);
            throw error;
        }
    }
};
